module.exports = __webpack_public_path__ + "static/img/job2.53e5dafb.jpg";